export default {
    state: {
		hasRouter: false // 动态路由存在flag
    },
    getters: {
		getHasRouter (state) { // 获取动态路由flag
			return state.hasRouter;
		}
    },
    mutations: {
		setHasRouter(state, hasRouter){ // 设置动态路由flag
			state.hasRouter = hasRouter;
		}
    },
    actions: {
        hasRouterAction (type) { // 提交修改动态路由flag action
			type.commit('setHasRouter');
		}
    }
}